import axios from "axios";
//http client
import {
  GET_PROJECTS,
  // ADD_PROJECT,
  DELETE_PROJECT,
  UPDATE_PROJECT,
  PROJECTS_LOADING,
  UPDATE_CONTACTLIST,
  LOGOUT_SUCCESS,
  PROJ_ERROR,
  PROJECT_NOTIFICATION,
  ADD_FOLDER,
  MODIFY_FOLDER,
  DELETE_FOLDER,
  ADD_PROJECT,
} from "./types";
import { tokenConfig } from "./authActions";
import configData from "./../configData";
// import { returnErrors } from "./errorActions";

export const updateContactList = (newCL) => (dispatch, getState) => {
  dispatch({
    type: UPDATE_CONTACTLIST,
    payload: newCL,
  });
};

function getProjectsAct(failCnt, dispatch, getState, info, folderBaseVersion) {
  axios
    .get(`${configData.SERVER_URL}projects`, tokenConfig(getState))
    .then((res) => {
      // axios will prevent us from doing httpRequest..

      dispatch({
        type: GET_PROJECTS,
        payload: { ...res.data, ...info, baseVersion: folderBaseVersion },
        // sending data as payload to reducer
      });
      dispatch({
        type: PROJECT_NOTIFICATION,
        payload: "",
      });
    })
    .catch(
      (error) => {
        console.log("err", error.response);
        // handle the case that someone with the free token tries to go to the projects
        if (error?.response?.data?.res === "Not the right token") {
          console.log("lfgjre");
          dispatch({
            type: LOGOUT_SUCCESS,
          });
        }
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          dispatch({
            type: PROJECT_NOTIFICATION,
            payload: error.response.data.res,
          });
          setTimeout(() => {
            dispatch({
              type: PROJECT_NOTIFICATION,
              payload: "",
            });
          }, 5000);
          console.log(error.response.status);
          console.log(error.response.headers);
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              ) {
                console.log("error", error.response);
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
              }
        } else if (error.request) {
          // The request was made but no response was received
          // (connection issue, lambda cold start, etc.) - retry with backoff
          console.log(error.request);
          if (failCnt > 0) {
            setTimeout(() => {
              console.log("getProjects call again, retries left", failCnt);
              getProjectsAct(
                failCnt - 1,
                dispatch,
                getState,
                info,
                folderBaseVersion,
              );
            }, 3000);
          } else {
            dispatch({
              type: PROJ_ERROR,
              payload:
                "Unable to load projects. Please check your connection and try again.",
            });
            setTimeout(() => {
              dispatch({
                type: PROJ_ERROR,
                payload: "",
              });
            }, 5000);
          }
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      }
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
}

export const duplicateProject = (info) => (dispatch, getState) => {
  dispatch({
    type: PROJECT_NOTIFICATION,
    payload: "Projects loading...",
  });
  setTimeout(() => {
    dispatch({
      type: PROJECT_NOTIFICATION,
      payload: "",
    });
  }, 10000);

  axios
    .post(
      `${configData.SERVER_URL}duplicateProject`,
      info,
      tokenConfig(getState)
    )
    .then((res) => {
      console.log("lkrjglekh", res.data);
      dispatch({
        type: ADD_PROJECT,
        payload: res.data,
      });
    })
    .catch((error) => {
      console.log("err", error.response);
      // handle the case that someone with the free token tries to go to the projects
      if (error?.response?.data?.res === "Not the right token") {
        console.log("lfgjre");
        dispatch({
          type: LOGOUT_SUCCESS,
        });
      }
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        dispatch({
          type: PROJECT_NOTIFICATION,
          payload: error.response.data.res,
        });
        setTimeout(() => {
          dispatch({
            type: PROJECT_NOTIFICATION,
            payload: "",
          });
        }, 5000);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
        setTimeout(() => {
          console.log("getItems call again");
          // getProjectsAct(failCnt - 1, dispatch, getState);
        }, 8000);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

export const getProjects = (info) => (dispatch, getState) => {
  dispatch({
    type: PROJECT_NOTIFICATION,
    payload: "Projects loading...",
  });
  setTimeout(() => {
    dispatch({
      type: PROJECT_NOTIFICATION,
      payload: "",
    });
  }, 10000);
  // dispatch for redux thunk
  console.log("getProjects called", getState);
  dispatch(setProjectsLoading());
  getProjectsAct(3, dispatch, getState, info, getState().project.folderVersion);
};

export const addFolder = (folderInfo) => (dispatch, getState) => {
  dispatch({
    type: PROJECT_NOTIFICATION,
    payload: "Projects loading...",
  });
  // setTimeout(() => {
  //   dispatch({
  //     type: PROJECT_NOTIFICATION,
  //     payload: "",
  //   });
  // }, 10000);
  // dispatch for redux thunk
  axios
    .post(`${configData.SERVER_URL}folder`, folderInfo, tokenConfig(getState))
    .then((res) => {
      // axios will prevent us from doing httpRequest..
      if (folderInfo.newFolder) {
        dispatch({
          type: ADD_FOLDER,
          payload: res.data,
          // sending data as payload to reducer
        });
      } else {
        dispatch({
          type: MODIFY_FOLDER,
          payload: res.data,
          // sending data as payload to reducer
        });
      }
      dispatch({
        type: PROJECT_NOTIFICATION,
        payload: "",
      });
    })
    .catch(
      (error) => {
        console.log("err", error.response);
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          dispatch({
            type: PROJECT_NOTIFICATION,
            payload: error.response.data.res,
          });
          setTimeout(() => {
            dispatch({
              type: PROJECT_NOTIFICATION,
              payload: "",
            });
          }, 5000);
          console.log(error.response.status);
          console.log(error.response.headers);
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              ) {
                console.log("error", error.response);
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
              }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      }
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const deleteFolder = (folderInfo) => (dispatch, getState) => {
  dispatch({
    type: PROJECT_NOTIFICATION,
    payload: "Projects loading...",
  });
  // setTimeout(() => {
  //   dispatch({
  //     type: PROJECT_NOTIFICATION,
  //     payload: "",
  //   });
  // }, 10000);
  // dispatch for redux thunk
  axios
    .delete(
      `${configData.SERVER_URL}folder/${folderInfo.folderId}`,
      tokenConfig(getState)
    )
    .then((res) => {
      // axios will prevent us from doing httpRequest..
      dispatch({
        type: DELETE_FOLDER,
        payload: folderInfo.folderId,
        // sending data as payload to reducer
      });

      dispatch({
        type: PROJECT_NOTIFICATION,
        payload: "",
      });
    })
    .catch(
      (error) => {
        console.log("err", error.response);
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          dispatch({
            type: PROJECT_NOTIFICATION,
            payload: error.response.data.res,
          });
          setTimeout(() => {
            dispatch({
              type: PROJECT_NOTIFICATION,
              payload: "",
            });
          }, 5000);
          console.log(error.response.status);
          console.log(error.response.headers);
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              ) {
                console.log("error", error.response);
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
              }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      }
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
};

//request to backend

export const updateProject = (updateInfo) => (dispatch, getState) => {
  // console.log(`obj to be sent:`);
  // console.log(updateInfo);
  // alert(`id ${updateInfo._id} left ${updateInfo.left} top ${updateInfo.top}`);
  // console.log("lkdjf");
  console.log("updateProject called ", updateInfo);
  if (updateInfo !== undefined) {
    axios
      .post(
        `${configData.SERVER_URL}projects/${updateInfo._id}`,
        updateInfo,
        tokenConfig(getState)
      )
      .then(
        (res) => {
          // dispatch({
          //   type: UPDATE_PROJECT,
          //   payload: res.data,
          // }); //,
          dispatch({
            type: PROJECT_NOTIFICATION,
            payload: "Project updated.",
          });
          setTimeout(() => {
            dispatch({
              type: PROJECT_NOTIFICATION,
              payload: "",
            });
          }, 5000);
        }
        // console.log(`response is`),
        // console.log(res.data)
      )
      .catch(
        (error) => {
          if (error.response) {
            // Request made and server responded
            console.log(error.response.data);
            // dispatch({
            //   type: PROJ_ERROR,
            //   payload: error.response.data.res,
            // });
            // setTimeout(() => {
            //   dispatch({
            //     type: PROJ_ERROR,
            //     payload: "",
            //   });
            // }, 5000);
            console.log(error.response.status);
            console.log(error.response.headers);
            if (error.response.data)
              if (error.response.data.res)
                if (
                  error.response.data.res.includes(
                    "err token or user undefined"
                  )
                ) {
                  console.log("error", error.response);
                  dispatch({
                    type: LOGOUT_SUCCESS,
                  });
                }
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
        }
        // dispatch(returnErrors(err.response.data, err.response.status))
      );
  }
};

export const deleteProject = (id) => (dispatch, getState) => {
  console.log("delete project", id);

  dispatch({
    type: PROJECT_NOTIFICATION,
    payload: "Data loading...",
  });
  setTimeout(() => {
    dispatch({
      type: PROJECT_NOTIFICATION,
      payload: "",
    });
  }, 10000);

  axios
    .delete(`${configData.SERVER_URL}projects/${id}`, tokenConfig(getState))
    .then((res) => {
      // attention to back ticks!!!
      console.log("delete proj res pos", res);
      dispatch({
        type: DELETE_PROJECT,
        payload: id,
      });
      dispatch({
        type: PROJECT_NOTIFICATION,
        payload: "",
      });
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        dispatch({
          type: PROJ_ERROR,
          payload: error.response.data.res,
        });
        setTimeout(() => {
          dispatch({
            type: PROJ_ERROR,
            payload: "",
          });
        }, 5000);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};

export const setProjectsLoading = () => {
  return {
    type: PROJECTS_LOADING,
  };
};

// before using database, itemAction returns to
// reducer type of action with information
// after: itemAction sets directly in database
// variables or gets items from database and
// dispatch action

//before: itemAction -> reducer
//after: itemAction -> database -> itemAction -> reducer
